/** Human-readable date/time for epoch-ms timestamps, used across views. */
export function formatDate(epochMs: number | null | undefined): string {
  if (epochMs === null || epochMs === undefined) return "—";
  return new Date(epochMs).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
